import React, { useEffect, useRef, useState } from 'react';
import { message, Table, Button, Typography, Modal, Select, Row, Col } from 'antd';
import moment from 'moment';
import { getReplenish, inventoryAddList, inventorySuppliers, inventoryMatchSupplier } from './api';
import { IndexForm } from './components';
import CpLoading from '../../components/CpLoading';
import './index.less';

const formatDate = 'YYYY-MM-DD';
const formateMoment = (values, value) => {
  let startTime, endTime;
  if (values?.length) {
    const [start, end] = values;
    startTime = moment(start).format(formatDate);
    endTime = moment(end).format(formatDate);
  }
  return { [`${value}_start`]: startTime, [`${value}_end`]: endTime };
};
const { Option } = Select;
export default function Index() {
  const [dataSource, setDataSource] = useState([]);
  const [modalDataSource, setModalDataSource] = useState([]);
  const [suppliersList, setSuppliersList] = useState([]);
  // const [categories, setCategories] = useState([]);
  const [pageConfig, setPageConfig] = useState({ page: 1, page_size: 50 });
  const [Loading, setLoading] = useState(true);
  const [visible, setVisible] = useState(false);
  const [totalPage, setTotalPage] = useState(1);
  const [selectItems, setSelectItems] = useState({ selectedRowKeys: [], selectedRows: [] });
  const [modalSelectItems, setModalSelectItems] = useState({ selectedRowKeys: [], selectedRows: [] });
  const [supplier, setSupplier] = useState(undefined);
  const childrenRef = useRef();
  const searchFn = () => { setPageConfig({ ...pageConfig, page: 1 }); };
  const tablePageChange = (page, pageSize) => {
    setPageConfig({ page, page_size: pageSize });
    setSelectItems({ selectedRowKeys: [], selectedRows: [] });
  };
  const columns = [
    {
      title: '商品信息',
      dataIndex: 'goods_name',
      key: 'goods_name',
      width: 240,
      render: text => text || '-'
    },
    {
      title: 'RMS商品编码',
      dataIndex: 'goods_code',
      key: 'goods_code',
      width: 120,
    },
    {
      title: '商品编号(SKU)',
      dataIndex: 'in_sku_no',
      key: 'in_sku_no',
      width: 140,
      render: text => text || '-'
    },
    {
      title: '商品单位',
      dataIndex: 'unit_name',
      key: 'unit_name',
      width: 100,
    },
    {
      title: '库存数量',
      dataIndex: 'stock',
      key: 'stock',
      width: 100,
      render: text => text || '-'
    },
    {
      title: '建议补货量',
      dataIndex: 'replenish_qty',
      key: 'replenish_qty',
      width: 130,
    },
    {
      title: '建议补货时间',
      dataIndex: 'replenish_time',
      key: 'replenish_time',
      width: 130,
      render: text => moment(text).format(formatDate)
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      width:80,
      render: (text, record) => {
        const { op_status } = record;
        // return op_status ? <Button type='primary' size='small' onClick={() => selectAllRequestItem(record)}>加入订货清单</Button> : <Typography.Link>供应商无该商品，暂不可订货</Typography.Link>;
        return op_status ? <Button type='primary' size='small' onClick={() => selectAllRequestItem(record)}>加入订货清单</Button> : '-';
      }
    }
  ];
  const modalColumns = [
    {
      title: '商品信息',
      dataIndex: 'goods_name',
      key: 'goods_name',
      render: (text, record) => {
        const { false_reason, add_cart } = record;
        return <><div>{text}</div><div>{add_cart ? null : <Typography.Link>{false_reason}</Typography.Link>}</div></>;
      }
    },
    {
      title: 'SKU商品编号',
      dataIndex: 'in_sku_no',
      key: 'in_sku_no',
    },
    {
      title: '单价',
      dataIndex: 'norms_price',
      key: 'norms_price',
    },
    {
      title: 'SKU商品单位',
      dataIndex: 'unit_name',
      key: 'unit_name',
    },
  ];
  useEffect(() => {
    async function getSuppliersList() {
      const { data: { code, msg, data } } = await inventorySuppliers();
      if (+code === 0) {
        const { list = [] } = data;
        setSuppliersList(list);
      } else {
        message.error(msg);
      }
    }
    getSuppliersList();
    // 采购建议-分类树
    // async function requestInventoryOutCategories(){
    //   const { data: { code, msg, data } } = await getInventoryOutCategories();
    //   console.log("🚀 ~ file: index.js ~ line 120 ~ requestInventoryOutCategories ~ data", data)
    //   if (+code === 0) {
    //     const { list = [] } = data;
    //     setCategories(list);
    //   } else {
    //     message.error(msg);
    //   }
    // }
    // requestInventoryOutCategories();
  }, []);
  useEffect(() => {
    async function requestReplenish() {
      const { goods_name, goods_code, replenish_time: replenish_time_date = [], result_time: result_time_date, replenish_type } = childrenRef.current.form.getFieldsValue() || {};
      const replenish_time = formateMoment(replenish_time_date, 'replenish_time');
      const result_time = result_time_date ? moment(result_time_date).format(formatDate) : '';
      const { data: { code, msg, data } } = await getReplenish({ goods_name, goods_code, replenish_type, ...replenish_time, result_time, ...pageConfig, replenish_qty_gt: '' });
      if (+code === 0) {
        const { list = [], total } = data;
        setDataSource(list.map((item, index) => ({ ...item, cIndex: index })));
        setTotalPage(total);
        setLoading(false);
      } else {
        message.error(msg);
      }
    }
    const timer = setTimeout(() => {
      requestReplenish();
      clearTimeout(timer);
      setLoading(false);
    });
  }, [pageConfig]);
  const rowSelection = {
    selectedRowKeys: selectItems.selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectItems({ selectedRowKeys, selectedRows });
    },
    getCheckboxProps: (record) => {
      const { op_status } = record;
      return { disabled: !op_status };
    },
  };
  const modalRowSelection = {
    selectedRowKeys: modalSelectItems.selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setModalSelectItems({ selectedRowKeys, selectedRows });
    },
    getCheckboxProps: (record) => {
      const { add_cart } = record;
      return { disabled: !add_cart };
    },
  };

  const selectAllRequest = () => {
    modalConfirm(selectItems.selectedRows || []);
  };
  const selectAllRequestItem = (record) => {
    modalConfirm([record] || []);
  };
  const modalConfirm = params => {
    setModalDataSource(params);
    setVisible(true);
  };
  const onSelectChange = async e => {
    const { data: { code, msg, data: resData = {} } } = await inventoryMatchSupplier({ supplier_id: e, data: modalDataSource });
    if (+code === 0) {
      const { data = [], supplier_id: supplier = '' } = resData;
      setModalDataSource(data);
      setSupplier(supplier);
      const selectedRows = data.filter(item => item.add_cart);
      const selectedRowKeys = selectedRows.map(item => item.cIndex);
      setModalSelectItems({ selectedRowKeys, selectedRows });
    } else {
      message.error(msg);
    }
  };
  const addToCart = async () => {
    const { data: { code, msg } } = await inventoryAddList({ supplier_id: supplier, data: modalSelectItems.selectedRows });
    if (+code === 0) {
      message.success(msg);
      const { selectedRowKeys: modalSelectedRowKeys = [] } = modalSelectItems;
      const modalSource = modalDataSource.filter(item => !modalSelectedRowKeys.includes(item.cIndex));
      const { selectedRowKeys = [], selectedRows = [] } = selectItems;
      const filterSelectedRowKeys = (selectedRowKeys || []).filter(item => !modalSelectedRowKeys.includes(item));
      const filterSelectedRows = (selectedRows || []).filter(item => !modalSelectedRowKeys.includes(item.cIndex));
      setModalDataSource(modalSource);
      setModalSelectItems({ selectedRowKeys: [], selectedRows: [] });
      setSelectItems({ selectedRowKeys: filterSelectedRowKeys, selectedRows: filterSelectedRows });
      !modalSource.length && closeModal();
    } else {
      message.error(msg);
    }
  };
  const closeModal = () => {
    setVisible(false);
    setModalSelectItems({ selectedRowKeys: [], selectedRows: [] });
  };

  return (
    <div className="order-list">
      <div className="title">采购建议</div>
      <div className="order-content">
        <IndexForm ref={childrenRef} searchFn={searchFn} />
      </div>
      {
        Loading ? <CpLoading /> : <>
          <Table
            bordered
            dataSource={dataSource}
            columns={columns}
            rowSelection={rowSelection}
            rowKey={record => record?.cIndex}
            pagination={{
              pageSize: pageConfig.page_size,
              total: totalPage,
              current: pageConfig.page,
              showSizeChanger: true,
              onChange: tablePageChange,
              showTotal: total => ` 共 ${total} 个商品 `
            }}
          />
          <div className='order-list-proposal-bottom'>
            <div className='order-list-proposal-bottom-sum'>已选择 {selectItems?.selectedRowKeys?.length} 件商品</div>
            <Button type='primary' size='large' disabled={!((selectItems?.selectedRowKeys || [])?.length)} onClick={selectAllRequest}>加入订货清单</Button>
          </div>
        </>
      }
      <Modal open={visible} destroyOnClose title='选择供应商' width={800} centered getContainer={false} footer={false} onCancel={closeModal} >
        <div>
          <Row className='modal-proposal'>
            <Col span={2}>供应商</Col>
            <Col span={12}>
              <Select
                showSearch
                placeholder='请选择供应商'
                style={{ minWidth: '100%' }}
                optionFilterProp="children"
                filterOption={(input, option) => option.children.includes(input)}
                onChange={(e) => onSelectChange(e)}>
                {(suppliersList || []).map(item => <Option value={item.company_id} key={item.company_id} >{item.company.name}</Option>)}
              </Select>
            </Col>
          </Row>
          <Table
            bordered
            dataSource={modalDataSource}
            columns={modalColumns}
            rowSelection={modalRowSelection}
            rowKey={record => record?.cIndex}
            pagination={false}
            scroll={{ y: 240 }}
          />
          <div className='modal-proposal-btn'><Button type='primary' disabled={!modalSelectItems?.selectedRowKeys?.length} onClick={addToCart}>确定</Button></div>
        </div>
      </Modal>
    </div>
  );
}
